import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent'
import ModalMediaComponent from 'app_components/commons/modalMedia'
import RoundedButtonComponent from 'app_components/commons/RoundedButtonComponent/RoundedButtonComponent'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { ILandingTutorial, LANDING_TUTORIAL_TYPE } from 'app_types/admin/landings/landingTypes'
import React, { FC, useState } from 'react'

import './TutorialsCard.scss'

const LogoImage = require('assets/images/logos/logo.png')

interface ITutorialsCardProps {
  tutorial: ILandingTutorial
}

const TutorialsCard: FC<ITutorialsCardProps> = ({ tutorial }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleClickOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  return (
    <div className='tutorials-card--layout'>
      {tutorial?.imageUrl?.length ? (
        <img src={tutorial.imageUrl} alt="" />
      ) : (
        <img src={LogoImage} alt="" className='tutorials-card--default-image' />
      )}
      <div className="tutorials-card--body">
        <div>
          <TextComponent color="var(--text3)" fontWeight={600}>
            {tutorial.title}
          </TextComponent>
          <LabelComponent fontWeight={400}>
            {LANDING_TUTORIAL_TYPE[tutorial.fileType]}
          </LabelComponent>
        </div>
        <TextComponent color="var(--text3)">
          {tutorial.description}
        </TextComponent>
        <div className='tutorials-card--actions'>
          {!!tutorial?.attachUrl && (
            <div>
              <a href={tutorial.attachUrl} target="_blank" rel="noreferrer">
                <RoundedButtonComponent borderColor='transparent'>
                  Descargar
                </RoundedButtonComponent>
              </a>
            </div>
          )}
          {!!tutorial?.videoUrl && (
            <div>
              <RoundedButtonComponent onClick={handleClickOpenModal}>
                Reproducir
              </RoundedButtonComponent>
            </div>
          )}
        </div>
      </div>
      <ModalMediaComponent
        open={isOpen}
        media={{
          name: tutorial.title,
          description: tutorial.description,
          type: 'youtube',
          url: tutorial?.videoUrl ? tutorial?.videoUrl : tutorial?.attachUrl,
        }}
        onClose={handleCloseModal}
        showName
      />
    </div>
  )
}

export default TutorialsCard
